(<template>
  <div class="list" id="monument-list" v-if="$session.exists() && $route.path !=='/'">
    <h1 v-translate>Monuments</h1>
    <div class="create-button-container">
      <el-button v-if="$session.exists() && $route.path !=='/'"
                 id="button-add-monument"
                 type="primary"
                 icon="el-icon-plus"
                 @click="$router.push('/monuments/create')"></el-button>
    </div>
    <div v-if="monumentList.length > 0">
      <el-table v-if="monumentList"
                id="monument-table"
                :data="monumentListPage"
                height="100%">
        <el-table-column class="monument-table-column">
          <template slot-scope="monument">
            <div class="monument-list-flex-container">
              <div class="monument-list-thumbnail">
                <img :src="monument.row.thumbnailUrl"/>
              </div>
              <div class="monument-list-content">
                <span @click="preview(monument.row.id)" class="clickable-text">
                  <strong>
                    {{monument.row.name}}
                  </strong>
                </span>
                <el-rate v-model="monument.row.rating"
                         disabled
                         show-score
                         text-color="#ff9900"
                         :score-template="points"></el-rate>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="monument">
            <el-button v-if="$session.exists() && $route.path !=='/'"
                       id="button-edit"
                       icon="el-icon-edit"
                       @click="edit(monument.row.id)"></el-button>
            <el-button v-if="$session.exists() && $route.path !=='/'"
                       id="button-delete"
                       type="danger" icon="el-icon-delete"
                       @click="remove(monument.row.id)"></el-button>
            <el-button type="info"
                       id="button-preview"
                       icon="el-icon-arrow-right"
                       @click="preview(monument.row.id)"></el-button>
            <el-button v-if="$session.exists() && $route.path !=='/'"
                       id="button-download-qr"
                       icon="el-icon-fa-qrcode"
                       @click="downloadQr(monument.row.id, monument.row.name)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-pagination background
                     layout="prev, pager, next"
                     :total="monumentList.length"
                     :current-page.sync="currentPage"
                     :page-size="pageSize"
                     @current-change="changePage">
      </el-pagination>
      <el-dialog v-if="$session.exists() && isEditVisible"
                 :before-close="handleClose"
                 :visible.sync="isEditVisible">
        <monument-upload-form :loaded-form="monument"
                              @close-edit="closeEdit"
                              preview></monument-upload-form>
      </el-dialog>
      <el-dialog :visible.sync="isPreviewVisible" :before-close="closePreview">
        <div v-if="isPreviewVisible" class="preview">
          <monument-detailed-view :id="monumentId" :preview="true"></monument-detailed-view>
        </div>
      </el-dialog>
    </div>
  </div>
</template>)

(<script>
import axios from 'axios'
import MonumentUploadForm from './Monument-Upload-Form.vue'
import MonumentDetailedView from './Monument-Detailed-View'

export default {
  name: 'monument-list',
  data () {
    var menuItems = {
      images: 'images',
      map: 'map',
      details: 'details',
      comments: 'comments'
    }
    return {
      points: `{value} ${this.$gettext('points')}`,
      menuItems,
      activeMenuImagesOrMap: menuItems.images,
      activeMenuDetailsOrComments: menuItems.details,
      isEditVisible: false,
      isPreviewVisible: false,
      monumentId: null,
      monument: null,
      monumentList: [],
      comments: [],
      currentPage: 1,
      pageSize: 10,
      monumentListPage: []
    }
  },
  created () {
    this.getMonumentList()
  },
  components: {
    'monument-upload-form': MonumentUploadForm,
    'monument-detailed-view': MonumentDetailedView
  },
  methods: {
    changePage () {
      this.monumentListPage = this.monumentList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    getMonumentUrl (id) {
      return `/#/monuments/${id}`
    },
    handleSelectImagesOrMap (key, keyPath) {
      this.activeMenuImagesOrMap = key
    },
    handleSelectDetailsOrComments (key, keyPath) {
      this.activeMenuDetailsOrComments = key
    },
    getMonumentList () {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/monuments?lang=${this.$language.current}`,
        withCredentials: true
      })
      .then(response => {
        this.monumentList = response.data
        this.monumentListPage = this.monumentList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    getMonument (id, callback) {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/monuments/${id}`,
        withCredentials: true
      })
      .then(response => {
        this.monument = response.data
        callback(null)
      })
      .catch(error => {
        var msg
        if (error.response) {
          msg = error.response.data || error.response.statusText
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
        callback(error)
      })
    },
    handleClose (done) {
      this.$confirm(this.$gettext('Please update if there were added or removed photo/audio files. Are you sure to close?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {})
    },
    closePreview (done) {
      this.activeMenuImagesOrMap = this.menuItems.images
      this.activeMenuDetailsOrComments = this.menuItems.details
      done()
    },
    edit (id) {
      this.getMonument(id, error => {
        if (!error) {
          this.isEditVisible = true
        }
      })
    },
    closeEdit () {
      this.isEditVisible = false
      this.getMonumentList()
    },
    remove (id) {
      this.$confirm(this.$gettext('Are you sure to delete the monument?'), {
        confirmButtonText: this.$gettext('Yes'),
        cancelButtonText: this.$gettext('No'),
        type: 'warning'
      }).then(() => {
        axios({
          method: 'delete',
          url: `${process.env.SERVER_URL}/monuments/${id}`,
          withCredentials: true
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$gettext('Delete has completed')
          })
          this.getMonumentList()
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$gettext('Delete has canceled')
        })
      })
    },
    downloadQr (id, name) {
      axios({
        method: 'get',
        url: `${process.env.SERVER_URL}/qr/download-qr?id=${id}`,
        withCredentials: true,
        responseType: 'blob'
      })
      .then((response) => {
        if (response.status === 200) {
          var fileUrl = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')
          fileLink.href = fileUrl
          fileLink.setAttribute('download', `${name}-QR.png`)
          document.body.appendChild(fileLink)

          fileLink.click()
        } else {
          this.$message({
            type: 'error',
            message: this.$gettext('Fail in downloading qr')
          })
        }
      })
      .catch(error => {
        console.log(error)
        this.$message({
          type: 'error',
          message: this.$gettext('Fail in downloading qr')
        })
      })
    },
    preview (id) {
      this.monumentId = id
      this.isPreviewVisible = true
    }
  }
}
</script>)

(<style>
#monument-table {
  height: 45em;
}
.create-button-container {
  text-align: right;
}
.monument-list-flex-container {
  height: 7em;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
}
.monument-list-content {
  margin: auto;
  width: 60%;
  text-align: center;
}
.monument-list-thumbnail {
  width: 40%;
  margin: auto;
  height: 80%;
  text-align: center;
}
.monument-list-thumbnail > img {
  height: 100%;
}
.preview {
  padding: 5%;
  padding-top: 1%;
  text-align: left;
  max-height: 40em;
  overflow-y: scroll;
  scroll-behavior: smooth;
  line-height: 1em;
}
@media screen and (max-width: 1300px) {
  .monument-list-flex-container {
    flex-direction: column;
    height: 10em;
  }
  .monument-list-thumbnail {
    height: 60%;
  }
}
.clickable-text {
  color: #0080E3;
  cursor: pointer;
  text-decoration: underline;
}
</style>)



// WEBPACK FOOTER //
// src/components/Monument-List.vue